// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Cdi2","error":"Textarea_error__1KKn9","readonly":"Textarea_readonly__1LpNQ","disabled":"Textarea_disabled__3_TeV"};